// extracted by mini-css-extract-plugin
module.exports = {"container":"marquee_container__rUbzZ","marquee":"marquee_marquee__MIa8l"};